import React from 'react';

import {Loading} from '../index';

// Tabs 组件加载占位符
export const TabsLoadingSkeleton: React.FC<{type?: 'mobile' | 'pc'}> = ({type = 'pc'}) => (
    <div
        style={{
            width: '100%',
            height: type === 'mobile' ? '100%' : '300px',
            display: 'flex',
            flexDirection: 'column',
            backgroundColor: '#fafafa',
            border: '1px solid #f0f0f0',
            borderRadius: '6px',
        }}
    >
        {/* Tab 头部骨架 */}
        <div
            style={{
                display: 'flex',
                padding: '16px',
                borderBottom: '1px solid #f0f0f0',
                gap: '16px',
            }}
        >
            {[1, 2, 3].map((i) => (
                <div
                    key={i}
                    style={{
                        width: '80px',
                        height: '20px',
                        backgroundColor: '#e8e8e8',
                        borderRadius: '4px',
                        animation: 'pulse 1.5s ease-in-out infinite',
                    }}
                />
            ))}
        </div>

        {/* 内容区骨架 */}
        <div
            style={{
                flex: 1,
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                fontSize: '14px',
                color: '#999',
            }}
        >
            <Loading style={{margin: '50px auto'}} />;
        </div>
    </div>
);
